// extracted by mini-css-extract-plugin
export default {"heroSection":"ContactsView_heroSection__7G7D8","contactInfo":"ContactsView_contactInfo__RuyNa","mapBox":"ContactsView_mapBox__Z86WW"};